<template>
  <div class="flex flex-col items-center">


        <PrintView class="border border-red-400" ref="printView"></PrintView>

    <el-button @click="onPrint">打印</el-button>

    <el-input v-model="formData.message" placeholder="请输入内容" show-password readonly disabled>
      <el-button slot="append" @click="reset" >重置</el-button>
    </el-input>

  </div>
</template>

<script>

import PrintView from "@/pages/guard/PrintView.vue";
import login from "@/pages/Login.vue";

export default {
  components: {PrintView},

  data() {
    return {
      formData: {
        message: "123456",
      },


    };
  },

  mounted() {
    /*
          printInfo: {
        visitorName: "",
        visitorCount: "",
        visitorCompany: "",
        visitorPhone: "",
        visitorReason: "",
        visitorCarNo: "",
        visitorCountry: "",
        visitorCardNo: "",
        enterArea: "",
        employeeDepartment: "",
        employeeName: "",
        enterTime: "",
        leaveTime: "",
        employeeSign: "",
        guardSign: "",
        qrCode: "",
        qrCodeImage: "",
        isProvider: false,
        saveArea: "",
      },

     */
    this.$refs.printView.setPrintInfo({
      visitorName: "test",
      visitorCount: "test",
      visitorCompany: "test",
      visitorPhone: "test",
      visitorReason: "test",
      visitorCarNo: "test",
      visitorCountry: "test",
      visitorCardNo: "test",
      enterArea: "test",
      employeeDepartment: "test",
      employeeName: "test",
      enterTime: "test",
      leaveTime: "test",
      employeeSign: "test",
      guardSign: "test",
      qrCode: "test",
      qrCodeImage: "test",
      isProvider: false,
      saveArea: "test",

    })
  },

  watch: {

  },

  methods: {

    onPrint() {
      this.$refs.printView.startPrint()
    },

    reset() {
      console.log("reset")
    },

  } // methods
}
</script>

<style scoped>
.el-scrollbar {
  width: ;
}
</style>
